/**
 * Created by Administrator on 2017/8/21.
 */
// import myProfile from '../components/my/myProfile'
// import healthIndex from "../components/health/healthIndex"
// import beautify from '../components/health/beautify'
// import gender from '../components/health/gender'
// import healthContent from '../components/health/healthContent'
// import season from '../components/health/season'
// import index from "../components/index/index"
// import serviceIndex from "../components/service/serviceIndex"
// import personInfo from '../components/my/personInfo'
// import about from '../components/my/about'
// import account from '../components/my/account'
// import myWait from '../components/my/myWait'
import healthFile from "../components/my/healthFile"
import ill from '../components/my/healthBasic/ill'
import pastHistory from '../components/my/healthBasic/pastHistory'
import familyHistory from '../components/my/healthBasic/familyHistory'
import allergyHistory from '../components/my/healthBasic/allergyHistory'
import addRecord from '../components/my/healthBasic/addRecord'
import deleteRecord from '../components/my/healthBasic/deleteRecord'
// import detailPage from '../components/my/healthBasic/detailPage'
// import myConsult from '../components/my/myConsult'
// import canceled from '../components/my/myConsult/canceled'
// import commented from '../components/my/myConsult/commented'
// import doing from '../components/my/myConsult/doing'
// import waitComment from '../components/my/myConsult/waitComment'
// import waitPay from '../components/my/myConsult/waitPay'
// import consultDetail from '../components/my/myConsult/consultDetail'
// import arrangeInfo from '../components/my/myConsult/arrangeInfo'
// import waitArrange from '../components/my/myConsult/waitArrange'
// import myBookNumber from '../components/my/myBookNumber'
import addUsualPatient from '../components/my/addUsualPatient'
import detailUsual from '../components/my/detailUsual'
// import costLog from '../components/my/costLog'
// import oldPhone from '../components/my/accountAbout/oldPhone'
// import changeUsualPhone from '../components/my/accountAbout/changeUsualPhone'
// import changePhoneSuccess from './accountAbout/changePhoneSuccess'
// import oldPass from '../components/my/accountAbout/oldPass'
// import changePassWord from '../components/my/accountAbout/changePassWord'
// import bookNumberDetail from '../components/my/bookNumberDetail'
// import cancelApply from '../components/my/myConsult/cancelApply'
import comment from '../components/my/myConsult/comment'
// import toggleAddUsual from '../components/my/toggleAddUsual'
// import bookToggleAddUsual from '../components/my/bookToggleAddUsual'
// import waitToggleAddUsual from '../components/my/waitToggleAddUsual'
// import checkToggleAddUsual from '../components/my/checkToggleAddUsual'
// import accountAbout from '../components/my/account/accountAbout.vue'
// import changePassword from '../components/my/account/changePassword.vue'
// import changePhone from '../components/my/account/changePhone.vue'
// import changePhoneSucc from '../components/my/account/changePhoneSucc.vue'
// import confrimPhone from '../components/my/account/confrimPhone.vue'
// import modificationPassword from '../components/my/account/modificationPassword.vue'
import succeed from '../components/my/account/succeed.vue'
// import userHelp from '../components/my/account/userHelp.vue'
// import expenseHistory from '../components/my/healthBasic/expenseHistory.vue'

// import detailDescription from '../components/my/account/detailDescription.vue'
import myDoc from "../page/my/doc.vue"
import myDocFollow from '../page/my/doc/follow'
import myDocMsg from '../page/my/doc/msg'
import myData from "../page/my/data.vue"

import myAuth from "../page/my/auth.vue"
import myEdit from "../page/my/edit.vue"
import {yyghType} from "@/lib/config";

export default [
  // 消费记录
  {
    path: "/expenseHistory",
    name: 'expenseHistory',
    redirect: to => {
      const {consultId} = to.query;
      if (consultId) {
        return `/team/consult/${consultId}`;
      }
      return '/my/pay';
    }
    // component: expenseHistory
  },
  /*{
    path: "/detailDescription",
    name: 'detailDescription',
    component: detailDescription
  },*/
  {
    path: "/userHelp",
    name: 'userHelp',
    redirect: '/v2/help'
    // component: userHelp
  },
  {
    path: "/accountAbout",
    name: 'accountAbout',
    component: () => import('../components/my/account/accountAbout.vue')
  },
  /*{
    path: "/changePassword",
    name: 'changePassword',
    component: changePassword
  },*/
  {
    path: "/changePhone",
    name: 'changePhone',
    component: () => import('../components/my/account/changePhone.vue')
  },
  /*{
    path: "/changePhoneSucc",
    name: 'changePhoneSucc',
    component: changePhoneSucc
  },*/
  {
    path: "/confrimPhone",
    name: 'confrimPhone',
    component: () => import('../components/my/account/confrimPhone')
  },
  /*{
    path: "/modificationPassword",
    name: 'modificationPassword',
    component: modificationPassword
  },*/
  {
    path: "/succeed",
    name: 'succeed',
    component: succeed
  },
  {
    path: '/myProfile',
    redirect: '/v2/my',
    /*component: myProfile,
    children: [
      {
        path: "healthIndex",
        component: healthIndex,
        children: [
          {
            path: "beautify",
            component: beautify
          },
          {
            path: "gender",
            component: gender
          },
          {
            path: "healthContent",
            component: healthContent
          },
          {
            path: "season",
            component: season
          },
        ]
      },
      {
        path: "index",
        component: index
      },
      {
        path: "serviceIndex",
        component: serviceIndex
      },
    ]*/
  },
  /*{
    path: "/personInfo",
    component: personInfo
  },*/
  {
    path: "/about",
    redirect: '/v2/about',
    //component: about
  },
  /*{
    path: "/account",
    component: account
  },*/
  /*{
    path: '/myWait',
    component: myWait
  },*/

  /**********健康档案开始**********/
  {
    path: "/healthFile",
    name: 'healthFile',
    component: healthFile
  },
  {
    path: "/ill",
    name: 'ill',
    component: ill
  },
  {
    path: "/pastHistory",
    name: 'pastHistory',
    component: pastHistory
  },
  {
    path: "/familyHistory",
    name: 'familyHistory',
    component: familyHistory
  },
  {
    path: "/allergyHistory",
    name: 'allergyHistory',
    component: allergyHistory
  },
  {
    path: "/addRecord",
    component: addRecord
  },
  {
    path: "/deleteRecord",
    name: 'deleteRecord',
    component: deleteRecord
  },
  /**********健康档案开始**********/
  /*{
    path: "/detailPage",
    component: detailPage
  },*/


  {
    path: "/myConsult/commented",
    // component: myConsult,
    redirect: '/my/consult',
  },

  /*{
    path: "/myConsult",
    // component: myConsult,
    redirect: '/myConsult/commented',
    children: [
      /!*{
        path: "canceled",
        component: canceled
      },*!/
      /!*{
        path: "commented",
        component: commented
      },*!/
      /!*{
        path: "doing",
        component: doing
      },
      {
        path: "waitComment",
        component: waitComment
      },
      {
        path: "waitPay",
        component: waitPay
      },*!/
    ]
  },*/
  /*{
    path: "/myConsult",
    // component: myConsult,
    redirect: '/my/consult',
    children: [
      {
        path: "online/canceled",
        component: canceled
      },
      {
        path: "online/commented",
        component: commented
      },
      {
        path: "online/doing",
        component: doing
      },
      {
        path: "online/waitComment",
        component: waitComment
      },
      {
        path: "online/waitPay",
        component: waitPay
      },
    ]
  },*/

  /*{
    path: "/consultDetail",
    component: consultDetail
  },*/
  /*{
    path: "/arrangeInfo",
    component: arrangeInfo
  },*/
  {
    path: '/waitArrange',
    redirect: to => `/team/consult/${to.query.consultId}`
    // component: waitArrange
  },
  {
    path: "/myBookNumber",
    redirect: to => {
      let orderInfo;
      try {
        orderInfo = JSON.parse(to.query.orderInfo);
      } catch (e) {
        orderInfo = {};
      }
      const {bookSort} = orderInfo;
      if (bookSort === yyghType[0]) {
        return '/my/book/list';
      } else if (bookSort === yyghType[2]) {
        return '/my/book/school'
      } else
        return `/my/book`
    },
    //component: myBookNumber
  },
  {
    path: "/my/book",
    component: () => import('../page/my/book'),
  },
  {
    path: "/my/book/list",
    component: () => import('../page/my/book/list'),
    children: [
      {path: ':id', component: () => import('../page/my/book/detail')},
    ]
  },
  {
    path: "/my/book/all",
    component: () => import('../page/my/book/all'),
  },
  {
    path: "/my/book/school",
    component: () => import('../page/my/book/school'),
    children: [
      {path: ':id', component: () => import('../page/my/book/school-detail')},
    ]
  },
  {
    path: "/usualPatient",
    redirect: '/my/patient',
    // component: () => import('../components/my/usualPatient')
  },
  // 添加就诊人
  {
    path: "/addUsualPatient",
    component: addUsualPatient,
    redirect: '/my/compat/add'
  },
  // 就诊人详情
  {
    path: "/detailUsual",
    component: detailUsual
  },
  /*{
    path: "/costLog",
    component: costLog
  },*/
  /*{
    path: "/oldPhone",
    component: oldPhone
  },*/
  /*{
    path: "/changeUsualPhone",
    component: changeUsualPhone
  },*/
  // {
  //   path:"/changePhoneSuccess",
  //   component:changePhoneSuccess
  // },
  /*{
    path: "/oldPass",
    component: oldPass
  },*/
  /*{
    path: "/changePassWord",
    component: changePassWord
  },*/
  /*{
    path: "/bookNumberDetail",
    component: bookNumberDetail
  },*/
  /*{
    path: "/cancelApply",
    component: cancelApply
  },*/
  {
    path: "/comment",
    component: comment
  },
  /*{
    path: "/toggleAddUsual",
    component: toggleAddUsual
  },*/
  {
    path: "/myBookNumberSelect",
    redirect: '/my/book'
    // component: () => import('../components/my/myBookNumberSelect')
  },
  /*{
    path: "/bookToggleAddUsual",
    component: bookToggleAddUsual
  },*/
  /*{
    path: "/waitToggleAddUsual",
    component: waitToggleAddUsual
  },*/
  /*{
    path: "/checkToggleAddUsual",
    component: checkToggleAddUsual
  },*/
  /*{
    path: "",
    redirect: "/myProfile",
    component: index
  },*/
  {
    path: "/my/doc",
    component: myDoc,
    children: [
      {path: 'msg', component: myDocMsg},
      {path: 'follow', component: myDocFollow},
      {path: 'group', component: () => import('../page/group/views/my')},
      {path: 'team', component: () => import('../page/my/doc/team')}
    ]
  },
  {path: '/chart/:id', component: () => import('../page/my/doc/chart')},
  {path: '/my/pay', component: () => import('../page/my/pay')},
  {path: '/my/patient', component: () => import('../page/my/patient')},
  {
    path: "/my/data",
    component: myData
  },
  {
    path: "/my/auth",
    component: myAuth
  },
  {
    path: "/my/edit",
    component: myEdit
  },
  {
    path: "/my/consult",
    component: () => import('../page/my/consult'),
    children: [
      {path: ':status', component: () => import('../page/my/consult/list')}
    ]
  },
  {
    path: "/my/medical",
    component: () => import('../page/my/medical'),
    children: [
      {path: 'team', component: () => import('../page/my/medical/team')},
      {path: 'outline', component: () => import('../page/my/medical/outline')},
      {path: ':status', component: () => import('../page/my/medical/list')}
    ]
  },
  {
    path: "/my/medical/outline/list",
    component: () => import('../page/my/medical/outline/list'),
  },
  /**
   * 团队体检订单详情
   * @query.id
   * @query.compatId
   * @cache.teamTjInfoCache
   */
  {
    path: "/my/medical/team/detail",
    component: () => import('../page/my/medical/team/detail'),
  },
  {
    path: "/my/medical/:id/detail",
    component: () => import('../page/my/medical/detail')
  },
  /**
   * @query.type [read,select]
   */
  {
    path: "/my/address/list",
    component: () => import('../page/my/address/list')
  },
  {
    path: "/my/address/add",
    component: () => import('../page/my/address/add')
  },
  /**
   * 推荐邀请码
   */
  {
    path: "/my/recommend",
    component: () => import('../page/my/recommend')
  },
  {
    path: '/my/recommend/list',
    component: () => import('../page/my/recommend/list')
  },
  /**
   * 个人中心
   */
  {
    path: '/my/index',
    redirect: '/v2/my'
    // component: () => import('../page/my/index')
  },
  /**
   * 修改个人预留地址
   * 选择就诊人
   */
  {
    path: '/my/hisaddr/select',
    component: () => import('../page/my/hisaddr/select')
  },
  /**
   * 选择医保卡
   */
  {
    path: '/my/hisaddr/list',
    component: () => import('../page/my/hisaddr/list')
  },
  /**
   * 验证身份证
   */
  {
    path: '/my/hisaddr/idcard',
    component: () => import('../page/my/hisaddr/idcard')
  },
  /**
   * 编辑地址
   */
  {
    path: '/my/hisaddr/edit',
    component: () => import('../page/my/hisaddr/edit')
  },
  /**
   * 结果
   */
  {
    path: '/my/hisaddr/result',
    component: () => import('../page/my/hisaddr/result')
  },
  /**
   * 病情描述
   */
  {
    path: '/my/illness',
    component: () => import('../page/my/illness/illness')
  },
  {
    path: '/my/illness/edit',
    component: () => import('../page/my/illness/edit')
  },
  {
    path: '/my/illness/result',
    component: () => import('../page/my/illness/result')
  },
  {
    path: '/my/prescription',
    component: () => import('../page/my/prescription')
  },
  {
    path: '/my/bczl',
    component: () => import('../page/my/consult/bczl.vue')
  },
  // 新版添加就诊人-step1
  {
    path: '/my/compat/add',
    component: () => import('../page/my/compat/add.vue')
  },
  // 新版添加就诊人-step2
  {
    path: '/my/compat/phone',
    component: () => import('../page/my/compat/phone.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/my.js